const SETTING_ACTION_TYPE = {
  GET_SETTINGS: 'GET_SETTINGS',
  GET_SETTING: 'GET_SETTING',
  UPDATE_SETTING: 'UPDATE_SETTING'
}
export default SETTING_ACTION_TYPE
